<template>
  <v-text-field
    autocomplete="on"
    class="input-styles e2e-input-password"
    type="password"
    :label="label"
    :rules="rules"
    :value="password"
    @input="(val) => update('password', val)"
    height="48"
    placeholder=" "
    outlined
    @blur="blur"
    persistent-placeholder
    required
  ></v-text-field>
</template>

<script>
export default {
  name: "PasswordInput",
  data() {
    return {
      rules: [],
    };
  },
  methods: {
    lengthRule(value) {
      return (value && value.length > 5) || "Min 6 characters";
    },
    requiredRule(value) {
      return !!value || "Required.";
    },
    blur() {
      this.rules = [this.lengthRule, this.requiredRule];
    },
  },
  props: { label: String, password: String, update: Function },
};
</script>
